import { MiscHelperService } from './../../../../sdk/services/custom/miscHelperService.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { AuthService } from './../../../../sdk/services/core/auth.service';
import { url } from './../../../cloudFrontUrl'
import { Component, OnInit, Input, OnChanges, EventEmitter, Output, ViewChild, ViewContainerRef, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { ListingApi } from './../../../../sdk/services/custom/listing.service';
import { ModalContainerComponent } from '../modal-container/modal-container.component';

@Component({
  standalone: true,
  selector: 'app-property-list-item',
  imports: [
    CommonModule,
    RouterModule,
    NzCardModule,
    NzButtonModule,
    NzGridModule,
    ModalContainerComponent,
  ],
  templateUrl: './property-list-item.component.html',
  styleUrls: ['./property-list-item.component.scss'],
})
export class PropertyListItemComponent implements OnInit, OnChanges, OnDestroy {
  @ViewChild('PropertyCompleteProgessHost', { read: ViewContainerRef, static: false }) public PropertyCompleteProgessHost: ViewContainerRef;
  PropertyCompleteProgessContainer;
  assetUrl: string;
 
  constructor(
    private authService: AuthService,
    private listingApi: ListingApi,
    private miscHelperService: MiscHelperService,
    private message: NzMessageService,
    private cdr: ChangeDetectorRef) {
    this.assetUrl = url;
  }
  @Input() nz_span = 8;
  @Input() remove_padding = false;
  @Input() display_type = 'grid-view';
  @Input() type = 'Sale';
  @Input() data;
  @Input() page = 'listing';
  @Input() displayHeart = false;
  @Input() propertyOwner = false;
  @Input() loggedIn = false;
  @Input() showListingStatus = false;
  routerUrlLink;
  @Input() favoritesComponent = false;
  @Input() heartColor = 'white';
  @Input() showTag = false;
  isAdmin = false;
  @Output() output = new EventEmitter();
  nzLgVar = { span: 6, offset: 0 };
  percentage_fields = 0;

  nzLg = 24;
  nzMd = 12;
  nzXs = 6;
  property_detail;
  user_id;
  @Input() status = false;
  current_user_email : any;

  @ViewChild('MlsChangeRequestHost', {
    read: ViewContainerRef,
    static: false,
  })
  public MlsChangeRequestHost: ViewContainerRef;
  MlsChangeRequestContainer;

  mslModalVisible : boolean= false;

  lstModalVisible : boolean= false;

  @ViewChild('ListingStepperHost', {
    read: ViewContainerRef,
    static: false,
  })
  public ListingStepperHost: ViewContainerRef;
  ListingStepperContainer;

  ngOnInit() {
    const { id, role,email } = this.authService.getAccessTokenInfo();
    this.user_id = id;
    this.current_user_email = email;
    // console.log(this.current_user_email);
    this.setPropertyDetail();
    if (!this.favoritesComponent){
      //this.loadPropertyCompleteProgess();
    }

  }
  
  private setPropertyDetail() {
    const thumbs = this.data?.listing_images_thumb;
    if (thumbs?.length) {
      const selected = thumbs.find((obj) => obj.display === true) || thumbs[0];
      if (selected) {
        const version = new Date().getTime();
        this.property_detail = {
          ...selected,
          src: selected.src && !selected.src.startsWith('data:') && !selected.src.startsWith('blob:')
            ? `${selected.src.split('?')[0]}?v=${version}`
            : selected.src,
        };
      }
    }
  }
  ngOnDestroy() {
    this.PropertyCompleteProgessHost?.clear();
  }

  updateHeartColor() {
    if (this.status === true) {
      this.heartColor = '#47c0bb';
    } else {
      this.heartColor = 'white';
    }
  }
  ngOnChanges() {
    if (this.loggedIn) {
      const { id, role,email } = this.authService.getAccessTokenInfo();
      this.user_id = id;
      this.current_user_email = email;
      this.authService.getAccessTokenInfo();
      this.user_id = id;
      const userIdExists = (obj) => obj.user_id === id;
      if (this.data.favorites) {
        if (this.data.favorites.some(userIdExists)) {
          this.status = true;
          this.updateHeartColor();
        }
      }
    }
    if (this.data) {
      this.setPropertyDetail();
      if (this.data.address) {
        if (!this.isAdmin) {
          this.routerUrlLink = this.miscHelperService.slugifyUrl(
            this.data.address.address,
            this.data._id
          );
        } else {
          this.routerUrlLink = `/admin/listings/listing-${this.data._id}`;
        }
      }
      if (this.data.completeness) {
        this.percentage_fields = this.data.completeness.percentage_fields;
        // console.log(' this.percentage_fields', this.percentage_fields)
      }
      this.type = this.data.listing_status?.status;
      if (this.nz_span) {
        this.nzLgVar = { span: this.nz_span, offset: 0 };
      }
    }

    this.nzLg = null;
    this.nzMd = null;
    this.nzXs = null;
  }
  openNewTab() {
    if (this.page !== 'listing') {
      const tempUrl = window.location.href;
      const finalUrl = tempUrl + '/' + this.routerUrlLink;
      window.open(finalUrl, 'blank');
    }
  }
  getListingAgain() {
    this.output.emit(null);
    this.message.success('Property has been removed from favorites', {
      nzDuration: 3500,
    });
  }
  favouriteClick(e) {
    e.stopPropagation();
    this.listingApi
      .updateListingFavorite(this.data._id, this.user_id, !this.status)
      .subscribe(
        (data) => {
          if (this.favoritesComponent) {
            this.getListingAgain();
            this.status = !this.status;
          } else {
            this.status = !this.status;
            this.updateHeartColor();
            if (this.status) {
              this.message.success('Property has been added to favorites', {
                nzDuration: 3500,
              });
            } else {
              this.message.success('Property has been removed from favorites', {
                nzDuration: 3500,
              });
            }
          }
        },
        (error) => {
          console.log('error', error);
          // const { message } = error.error;
          // this.message.error(message, {
          //   nzDuration: 3500
          // });
        }
      );
  }
  loadPropertyCompleteProgess(){
    import('./../property-complete-progress/property-complete-progress.module').then(({ PropertyListItemComponentModule }) => {
      const NewPropertyListItemComponent = PropertyListItemComponentModule.getPropertyCompleteProgress();
      const factory = NewPropertyListItemComponent;
      this.PropertyCompleteProgessHost?.clear();
      this.PropertyCompleteProgessContainer = this.PropertyCompleteProgessHost.createComponent(factory);
      this.PropertyCompleteProgessContainer.instance.listing_detail = this.data;
      // this.PropertyCompleteProgessContainer.instance.is_seller_2 = this.data?.is_seller_2;
      // this.PropertyCompleteProgessContainer.instance.document_completeness = this.data?.document_completeness;
      // this.PropertyCompleteProgessContainer.instance.percentage_fields = this.percentage_fields;
      this.PropertyCompleteProgessContainer.instance.from_list = true;
    });  
  }

   closeMlsRequestModal() {
    this.mslModalVisible = false;
    this.MlsChangeRequestHost?.clear();
  }

  openMlsRequestModal() {
    this.mslModalVisible = true;
  }

  loadMlsChangeRequestPopup(listingData) {
    this.openMlsRequestModal();
    this.cdr.detectChanges();
    import('../mls-change-request/mls-change-request.module').then(({ MlsChangeRequestModule }) => {
      const NewMlsChangeRequestComponent = MlsChangeRequestModule.getMlsChangeRequestComponent();
      const factory = NewMlsChangeRequestComponent;
      const attach = (attempts = 0) => {
        if (!this.MlsChangeRequestHost) {
          if (attempts < 30) {
            setTimeout(() => attach(attempts + 1), 0);
          }
          return;
        }
        this.MlsChangeRequestHost.clear();
        this.MlsChangeRequestContainer = this.MlsChangeRequestHost.createComponent(factory);
        this.MlsChangeRequestContainer.instance.listing_id = listingData._id;
        this.MlsChangeRequestContainer.instance.address = listingData.address.address;
        this.MlsChangeRequestContainer.instance.user_info = listingData.user_info;
        this.MlsChangeRequestContainer.instance.close.subscribe(() => {
          this.closeMlsRequestModal();
        });
      };
      attach();
    });
  }

  loadListingStepperPopup() {
    this.openModal();
    this.cdr.detectChanges();
    import('./../listing-stepper-modal/listing-stepper-modal.module').then(({ ListingStepperModalModule }) => {
      const ListingStepperModalComponent = ListingStepperModalModule.getListingStepperModalComponent();
      const factory = ListingStepperModalComponent;
      const attach = (attempts = 0) => {
        if (!this.ListingStepperHost) {
          if (attempts < 30) {
            setTimeout(() => attach(attempts + 1), 0);
          }
          return;
        }
        this.ListingStepperHost.clear();
        this.ListingStepperContainer = this.ListingStepperHost.createComponent(factory);
        this.ListingStepperContainer.instance.listing_detail = this.data;
        this.ListingStepperContainer.instance.router_url_link = this.routerUrlLink;
        this.ListingStepperContainer.instance.close.subscribe(() => {
          this.closeModal();
        });
      };
      attach();
    });
  }

  closeModal() {
    this.lstModalVisible = false;
    this.ListingStepperHost?.clear();
    document.body.classList.remove('custom-scroll');
  }

  openModal() {
    document.body.classList.add('custom-scroll');
    this.lstModalVisible = true;
  }
   getWrapClass() {
    if (window.innerWidth <= 480) {
      return 'listing-stepper-mobile';
    }
    return 'listing-stepper';
  }

 isStateExcluded(state: string): boolean {
  const excludedStates = ['LA', 'Louisiana', 'AL', 'Alabama'];
  if (!state) return false;
  return excludedStates.some(excludedState =>
    state === excludedState || state.includes(excludedState)
  );
}

  shouldShowActionSection(data: any): boolean {
    if (!data) return false;

    if (this.isStateExcluded(data.address?.state)) {
      return (
        data.is_sign_listing_doc !== 'Completed' ||
        data.is_property_info !== 'Completed' ||
        data.is_photo_uploaded !== 'Completed'
      );
    } else {
      return (
        data.is_sign_listing_doc !== 'Completed' ||
        data.is_property_info !== 'Completed' ||
        data.is_property_disclosure !== 'Completed' ||
        data.is_photo_uploaded !== 'Completed'
      );
    }
  }

  isAllCompleted(data: any): boolean {
    if (!data) return false;

    if (this.isStateExcluded(data.address?.state)) {
      return (
        data.is_sign_listing_doc === 'Completed' &&
        data.is_property_info === 'Completed' &&
        data.is_photo_uploaded === 'Completed'
      );
    } else {
      return (
        data.is_sign_listing_doc === 'Completed' &&
        data.is_property_info === 'Completed' &&
        data.is_property_disclosure === 'Completed' &&
        data.is_photo_uploaded === 'Completed'
      );
    }
  }


}
